<ion-nav [root]="root" mode="ios"></ion-nav>
<!-- <ion-router-outlet #modalOutlet name="modal"></ion-router-outlet> -->